// extracted by mini-css-extract-plugin
module.exports = {"modal":"pM_HPNs","desktop":"HrqK6Th"};